export const typesUsercreddet = {
    
    GET_SAVEUSERCRED_SUCCESS:'GET_SAVEUSERCRED_SUCCESS',
    GET_SAVEUSERCRED_CUSTOM_SUCCESS:'GET_SAVEUSERCRED_CUSTOM_SUCCESS',
    

    GET_SAVEUSERCRED_ERROR:'GET_SAVEUSERCRED_ERROR',
    GET_SAVEUSERCRED_BEGIN:'GET_SAVEUSERCRED_BEGIN',
    GET_SAVEUSERCRED_LOGOUT:'GET_SAVEUSERCRED_LOGOUT'


}
